import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DixaIcon from '@dixa/dixa-modern-icons';
import { Avatar, Button, IconButton, Tooltip } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { Component } from 'react';
import { buttonize } from 'components/shared/util/buttonize';
import { numberFormatterInternational } from '../../../../app/utils/telephonyHelpers';
import styles from './userItem.module.scss';
export default class UserItem extends Component {
    constructor(props) {
        super(props);
        this.toggle = () => {
            this.setState({ isOpen: !this.state.isOpen });
        };
        this.state = {
            isOpen: false,
        };
    }
    render() {
        var _a;
        const { className, user, profile, disabled, metaConversation, highlighted, numberTransferRequests, transferToAgentRequests, asyncStatus, onAssistedTransferClick, onBlindTransferClick, } = this.props;
        const { isOpen } = this.state;
        const rootClass = classnames({
            [styles.root]: true,
            [styles.highlighted]: highlighted,
            [styles.isOpened]: isOpen,
            [styles.isClosed]: !isOpen,
        }, className);
        let name = '';
        let isNumberShown = false;
        let toPhoneNumberFormat = '';
        let avatarClasses = '';
        let disabledRender = disabled;
        let reassignDescription = 'Transfer conversation #' + metaConversation.conversation.id;
        if (disabledRender === '') {
            toPhoneNumberFormat = numberFormatterInternational({
                phoneNumber: user.phone_number,
            });
            if (((_a = metaConversation.requester) === null || _a === void 0 ? void 0 : _a.id) === user.id) {
                disabledRender = 'disabled';
                avatarClasses = 'dim';
                reassignDescription = 'This user is already in the conversation.';
            }
            if (disabledRender === '' && user.id === profile.id) {
                disabledRender = 'disabled';
                avatarClasses = 'dim';
                reassignDescription = 'You cannot transfer to yourself.';
            }
            const requestToAgent = transferToAgentRequests.find((request) => request.metaConversation.conversation.id ===
                metaConversation.conversation.id);
            const requestToNumber = numberTransferRequests.find((request) => request.metaConversation.conversation.id ===
                metaConversation.conversation.id);
            if (requestToAgent !== undefined || requestToNumber !== undefined) {
                disabledRender = 'disabled';
                avatarClasses = 'dim';
                reassignDescription = 'Request already sent waiting for response.';
            }
        }
        else if (asyncStatus === 'loading') {
            reassignDescription = 'Loading';
            disabledRender = 'disabled';
        }
        if (disabledRender === 'disabled') {
            avatarClasses = 'dim';
        }
        if (typeof user.name === 'string' ||
            typeof user.display_name === 'string') {
            name = typeof user.name === 'string' ? user.name : user.display_name;
        }
        else if (typeof user.phone_number === 'string') {
            name = user.phone_number;
            isNumberShown = true;
        }
        else if (typeof user.email === 'string') {
            name = user.email;
        }
        return (_jsxs("div", Object.assign({ className: rootClass }, buttonize(this.toggle), { children: [_jsx("div", Object.assign({ className: avatarClasses, style: { display: 'inline-block', float: 'left' } }, { children: user.icon !== undefined ? (_jsx(DixaIcon, { className: "s-icon loading-image", icon: user.icon })) : (_jsx(Avatar, { user: user })) })), _jsx(Tooltip, Object.assign({ content: name, dark: true }, { children: _jsx("span", Object.assign({ className: styles.name }, { children: name })) })), _jsx("span", Object.assign({ className: styles.type }, { children: isNumberShown === false && user.phone_number !== null
                        ? toPhoneNumberFormat
                        : 'Contact' })), _jsx(Tooltip, Object.assign({ content: reassignDescription, dark: true }, { children: _jsx(IconButton, { icon: this.state.isOpen === true ? 'arrow-down' : 'arrow-right', className: styles.toggle, variant: "tertiary", onClick: this.toggle }) })), _jsxs("div", Object.assign({ className: this.state.isOpen === true ? 'toggle-closed' : 'hidden' }, { children: [_jsx(Tooltip, Object.assign({ content: reassignDescription, dark: true }, { children: _jsx(Button, Object.assign({ variant: "secondary", type: "button", style: { marginRight: '8px' }, disabled: disabledRender === 'disabled', onClick: disabledRender === 'disabled'
                                    ? () => {
                                        /** Noop. */
                                    }
                                    : () => {
                                        onBlindTransferClick({ requestToUser: user });
                                    }, className: styles.btnTransferNow }, { children: "Transfer now" })) })), _jsx(Tooltip, Object.assign({ content: reassignDescription, dark: true }, { children: _jsxs(Button, Object.assign({ variant: "secondary", disabled: disabledRender === 'disabled', type: "button", onClick: disabledRender === 'disabled'
                                    ? () => {
                                        /** Noop. */
                                    }
                                    : () => {
                                        onAssistedTransferClick({ requestToUser: user });
                                    }, className: styles.btnTalkToFirst }, { children: ["Talk to ", name, " first"] })) }))] }))] })));
    }
}
